import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { OrderHistoryProductModel } from "@store/Types/ApiModels";

const productInContext = (
    selectedProduct: OrderHistoryProductModel,
    onQtyOrderedChanged?: (qtyOrdered: number) => void,
) => {
    const productInfo: any = {
        productId: selectedProduct.autocompleteItemModel.id || "",
        qtyOrdered: selectedProduct.qtyOrdered,
    };

    const product: any = {
        id: selectedProduct.autocompleteItemModel.id || "",
        imageAltText: selectedProduct.autocompleteItemModel.name,
        largeImagePath: selectedProduct.autocompleteItemModel.image,
        manufacturerItem: selectedProduct.autocompleteItemModel.manufacturerItemNumber,
        mediumImagePath: selectedProduct.autocompleteItemModel.image,
        productNumber: selectedProduct.autocompleteItemModel.erpNumber,
        productTitle: selectedProduct.autocompleteItemModel.name,
        smallImagePath: selectedProduct.autocompleteItemModel.image,
        urlSegment: selectedProduct.autocompleteItemModel.url,
    };

    return { product, productInfo, onQtyOrderedChanged } as ProductContextModel;
};

export default productInContext;
